export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Security',
      description: 'Advanced encryption protocols protect your data and ensure complete privacy across all our applications.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Optimized Performance',
      description: 'Lightweight applications designed for maximum efficiency without compromising device performance.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'User-Centric Design',
      description: 'Intuitive interfaces crafted with user experience in mind, making complex features simple to use.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features to keep your apps current with the latest iOS capabilities.'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Dedicated support team ready to assist you with any questions or technical issues.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Reach',
      description: 'Serving users worldwide with localized support and optimized server infrastructure.'
    }
  ];

  return (
    <section id="features" className="py-32 bg-[#0A1628] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-[#50E3C2]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#4A90E2]/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-block px-6 py-2 rounded-full bg-[#D4AF37]/20 text-[#D4AF37] text-sm font-semibold mb-6 tracking-wide">
            WHY CHOOSE US
          </div>
          <h2 className="text-6xl font-serif text-white mb-6">Excellence in Every Detail</h2>
          <p className="text-xl text-gray-300 font-light max-w-3xl mx-auto">
            Our commitment to quality and innovation sets us apart in the iOS development landscape
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 hover:bg-white/10 transition-all duration-300 border border-white/10 hover:border-[#50E3C2]/50 group cursor-pointer"
            >
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#4A90E2] to-[#50E3C2] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-gray-300 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Testimonial Section */}
        <div className="mt-32 grid grid-cols-5 gap-12 items-center">
          {/* Left Image */}
          <div className="col-span-2">
            <div className="rounded-3xl overflow-hidden shadow-2xl relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/5d61b97334ed79147a643753c5a1d0c3.jpg"
                alt="iOS Device Mockup"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#4A90E2]/30 to-transparent"></div>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-span-3 pl-12">
            <div className="text-[#D4AF37]/30 text-8xl font-serif mb-6">"</div>
            <p className="text-3xl font-serif text-white leading-relaxed mb-8">
              JUMI S.R.L. has transformed how we think about mobile security. Their VPN solution is not only powerful but incredibly easy to use. The attention to detail in every aspect of their applications is remarkable.
            </p>
            <div className="flex items-center gap-4">
              <div className="w-16 h-1 bg-[#D4AF37]"></div>
              <div>
                <div className="text-xl font-bold text-white">Sarah Mitchell</div>
                <div className="text-gray-400">Technology Reviewer</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
